import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import { FormGroup, TextField, Select, CheckboxGroup } from 'components';
import { $Helptext, $Input, $Label } from 'styles';

// DEV_PORTAL_TODO: These should be component and invert the control of customising them. eg elem
const getInputType = (name) => {
  const lowerName = name.toLowerCase();
  if (lowerName.includes('password')) return 'password';
  if (lowerName.includes('date')) return 'date';
  return 'text';
};

export const getFormTextField = (form, field, appendElem) => {
  const { values, errors, touched, handleChange } = form;
  const { label, name, helptext, type, ...rest } = field;

  const formField = (
    <FormGroup styledProps={{ variant: 'stacked' }}>
      <TextField
        data-cy={`auth_input_${name}`}
        helptext={(errors[name] && touched[name] && errors[name]) || helptext}
        isErrored={errors[name] && touched[name]}
        type={getInputType(name)}
        label={label}
        name={name}
        onChange={handleChange}
        value={values[name]}
        {...rest}
      />
      {appendElem}
    </FormGroup>
  );

  return formField;
};

export const getFormCurrencyField = (form, field) => {
  const { values, errors, touched, setFieldValue } = form;
  const { label, name, helptext, isDisabled, ...rest } = field;
  const value = values[name];
  const isErrored = !!(errors[name] && touched[name]);

  return (
    <FormGroup styledProps={{ variant: 'stacked' }}>
      {label && (
        <$Label htmlFor={name} id={`${name}Label`}>
          {label}
        </$Label>
      )}
      <CurrencyInput
        id={name}
        name={name}
        data-cy={`auth_input_${name}`}
        customInput={$Input}
        decimalsLimit={2}
        decimalScale={2}
        allowNegativeValue={false}
        disabled={isDisabled}
        isErrored={isErrored}
        value={typeof value === 'number' ? value.toFixed(2) : value}
        onValueChange={val => setFieldValue(name, val)}
        {...rest}
      />
      <$Helptext
        id={`${name}Description`}
        data-cy={`${name}Description`}
        isErrored={isErrored}
      >
        {(isErrored && errors[name]) || helptext || ''}
      </$Helptext>
    </FormGroup>
  );
};

export const getFormSelectField = (form, field) => {
  const { values, errors, touched, handleChange } = form;
  const { label, name, defaultValue, options, helptext } = field;

  const formField = (
    <FormGroup styledProps={{ variant: 'stacked' }}>
      <Select
        data-cy={`auth_input_${name}`}
        defaultValue={defaultValue}
        helptext={(errors[name] && touched[name] && errors[name]) || helptext}
        isErrored={errors[name] && touched[name]}
        label={label}
        name={name}
        onChange={handleChange}
        options={options}
        value={values[name]}
        styledProps={{ fontSize: 'md', optionFontSize: 'lg' }}
      />
    </FormGroup>
  );

  return formField;
};

export const getFormCheckboxGroup = (form, field) => {
  const { values, errors, touched, handleBlur, handleChange } = form;
  const {
    label,
    name,
    options,
    helptext,
    entireGroupValidation,
    chkBoxStyledProps,
  } = field;

  function getHelpText() {
    if (entireGroupValidation) {
      return (errors[name] && errors[name]) || helptext;
    }
    return (errors[name] && touched[name] && errors[name]) || helptext;
  }

  function isErrored() {
    if (entireGroupValidation) {
      return !!errors[name];
    }
    return errors[name] && !!touched[name]; // TODO: This is a bit of a bug we'll have to fix later, touched doesn't work so well with arrays.
  }

  const formField = (
    <FormGroup styledProps={{ variant: 'stacked' }}>
      <CheckboxGroup
        data-cy={`auth_input_${name}`}
        groupLabel={label}
        groupName={name}
        helptext={getHelpText()}
        isErrored={isErrored()}
        onBlur={handleBlur}
        onChange={handleChange}
        options={options}
        valuesArray={values[name]}
        entireGroupValidation={entireGroupValidation}
        chkBoxStyledProps={chkBoxStyledProps || {}}
      />
    </FormGroup>
  );

  return formField;
};
